/**
 * L-NAV-7 — « Équipe » : `/equipe` (liste) + `/equipe/:userId` (fiche).
 *
 *   · `/admin/users` (ancienne page Utilisateurs, devenue la liste) → `/equipe` ;
 *   · `/admin/permissions` (ancienne page Permissions, supprimée : les accès
 *     se règlent sur la fiche de CHAQUE personne, section « Accès ») →
 *     `/equipe` AVEC un bandeau qui le dit (état de navigation
 *     `teamNotice: 'permissionsMoved'`, lu par la liste).
 *
 * Comme les redirections L-NAV-3/4/5 : la REQUÊTE est conservée (`/admin/users`
 * porte son état dans l'URL depuis #259 — `?client=…&q=…&role=…`), le fragment
 * aussi, et `location.state` suit (registre §5 : un `<Navigate>` nu perd
 * requête ET état — `state.from` d'un ancien lien ne ramènerait plus rien).
 *
 * Gardes : la route cible porte sa `ProtectedRoute` (rôle ADMIN, comme les
 * deux anciennes routes) — un agent qui suit un vieux signet aboutit, comme
 * avant, sur le refus d'accès.
 *
 * `replace` : pas d'entrée d'historique (sinon « précédent » boucle).
 *
 * Helper exporté (pas écrit en clair dans `App.tsx`) pour que
 * `legacyTeamRedirects.spec.tsx` monte les VRAIES routes, et que
 * `AppShell.routeTitles.spec.ts` (qui lit les `<Route path>` du source) ne les
 * prenne pas pour des pages sans titre.
 */
import { Navigate, Route, useLocation } from 'react-router-dom'

export const TEAM_PATH = '/equipe'

/** Clé de l'état de navigation qui porte le bandeau de la liste. */
export const TEAM_NOTICE_STATE_KEY = 'teamNotice'
export type TeamNotice = 'permissionsMoved'

export const LEGACY_TEAM_REDIRECTS: ReadonlyArray<{ from: string; notice?: TeamNotice }> = [
  { from: '/admin/users' },
  { from: '/admin/permissions', notice: 'permissionsMoved' },
]

function LegacyTeamRedirect({ notice }: { notice?: TeamNotice }) {
  const location = useLocation()
  const previous = location.state && typeof location.state === 'object' ? (location.state as Record<string, unknown>) : null
  const state = notice ? { ...(previous ?? {}), [TEAM_NOTICE_STATE_KEY]: notice } : location.state
  return <Navigate to={{ pathname: TEAM_PATH, search: location.search, hash: location.hash }} state={state} replace />
}

/** Routes à insérer dans l'arbre AUTHENTIFIÉ, avant le `*` de la 404. */
export function legacyTeamRedirects() {
  return LEGACY_TEAM_REDIRECTS.map(({ from, notice }) => (
    <Route key={from} path={from} element={<LegacyTeamRedirect notice={notice} />} />
  ))
}
